import React from 'react'
import ProgramList from '../../Components/Program/Program'
import './Program.scss'

export default function Program() {

  return (
    <div className='Program-Page'>
      <ProgramList />
    </div>
    
  )
}
